type Props = {
    sold:boolean,
    res:boolean,
    title:string,
}


export default function ({sold, res, title}:Props){
    if (title.length === 1) {
  title = 'G0' + title;
} else if (title.length === 2) {
  title = 'G' + title;
}
    if(!sold && !res) return <div className="SaleIndicatorJustText">{title}</div>;

    return (
        <div className="SaleIndicator" data-res={res} data-sold={sold}>
            <div>{ sold ? "SOLD" : res ? "RES" : ""}</div>
        </div>
    )
}